// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1OxoB","ranges":"BmiRanges_ranges__1vmYY"};